<template>
    <md-dialog :md-fullscreen="false" :md-active="show">
        <div style="position:relative;">
            <md-button @click="close" class="closeX">
                X
            </md-button>
        </div>

        <div class="text-center mt16 ml16 mb16">
            <div class="uppercase" style="padding-right:36px">
                Potwierdź numer telefonu
            </div>
        </div>

        <div class="text-center ml16 mr16 mb">
            <div v-html="$t('modals.onThisPhoneSmshasBeenSent')" />

            <div class="center-pin-box">
                <PinForm
                    @submit="submit"
                    @pin="
                        e => {
                            pin = e;
                        }
                    "
                />
            </div>

            <small
                v-if="pinCounter < 2 || pinCounter === undefined"
                class="right pt15"
                ><div @click="beforeSendPIN">
                    {{ $t('modals.IDontHaveReceivedTextMessage') }}
                </div></small
            >
        </div>

        <md-dialog-actions>
            <md-button
                class="default-button btn-get-passenger-small"
                @click="submit(pin)"
            >
                {{ $t('route.sendDeposit') }}
            </md-button>
        </md-dialog-actions>
    </md-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import PinForm from '../components/Pin';

export default {
    components: {
        PinForm
    },

    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: true,
            pin: '',
            pinCounter: this.getSavedState('pin')
                ? this.getSavedState('pin')
                : 0
        };
    },

    watch: {
        show(e) {
            const { phonecode } = this.currentPassenger;

            if (e && !phonecode) {
                this.sendPIN();
            }
        }
    },

    computed: {
        ...mapGetters({
            currentPassenger: 'auth/currentPassenger'
        })
    },

    methods: {
        ...mapActions({
            verifyPhoneNumber: 'auth/loginByPhoneNumberAsPassenger',
            checkPin: 'auth/checkPin',
            getPassenger: 'auth/validatePassengerToken'
        }),

        close() {
            this.$emit('close');
        },

        async submit(pin) {
            console.log(pin.length);

            if (pin.length < 6) {
                this.$toast.error(this.$t('modals.incorrectCode'));
                return;
            }

            const { phonenumber } = this.currentPassenger;

            const params = { phone: phonenumber, pin };

            const response = await this.checkPin(params);

            if (response) {
                this.close();

                this.$toast.success(this.$t('modals.phonehHsBeenConfirmed'));
            } else {
                this.$toast.error(this.$t('modals.incorrectCode'));
            }
        },

        async beforeSendPIN() {
            this.pinCounter = this.pinCounter + 1;
            this.saveState('pin', this.pinCounter);

            if (this.pinCounter < 2) {
                this.sendPIN();
            }
        },

        async sendPIN() {
            const { phonenumber } = this.currentPassenger;
            const response = await this.verifyPhoneNumber(phonenumber);

            if (response) {
                this.saveState(pin, pinCounter + 1);
                await this.getPassenger();
                this.$toast.success(this.$t('auth.smsWithCodeHasBeenSent'));
            } else {
                this.$toast.error(this.$t('global.incorrectLoginCredentials'));
            }
        },

        getSavedState(key) {
            return JSON.parse(window.localStorage.getItem(key));
        },

        saveState(key, state) {
            window.localStorage.setItem(key, JSON.stringify(state));
        }
    }
};
</script>
<style>
.md-dialog-container.md-theme-default {
    overflow: initial !important;
}

.center-pin-box {
    max-width: 400px;
    margin: 0 auto;
    display: flow-root;
}

small div {
    cursor: pointer;
}
</style>
